import React from "react";
import {
  Box,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const parseComplementosDespacho = (texto: string) => {
  if (!texto) return {};

  const get = (label: string, ate: string[]) => {
    const atePattern = ate.length
      ? `(?=${ate.map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")}|$)`
      : "$";
    const r = new RegExp(
      `${label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}:\\s*(.+?)\\s*${atePattern}`,
      "s"
    );
    return texto.match(r)?.[1]?.trim() ?? null;
  };

  return {
    protocolo: get("Protocolo", ["Petição (tipo)", "Requerente", "Procurador"]),
    peticao_tipo: get("Petição (tipo)", ["Requerente", "Procurador"]),
    requerente: get("Requerente", ["Procurador"]),
    procurador: get("Procurador", []),
  };
};

export const ProcessPublications = ({ petitions }) => {
  // Coleta todas as publicações de todas as petições
  const publicacoes =
    petitions?.flatMap((peticao) =>
      (peticao.publicacoes_processo_rpi || []).map((pub) => ({
        ...pub,
        // Mantém referência à petição para contexto, se necessário
        _peticaoProtocolo: peticao.numero_protocolo,
      }))
    ) ?? [];

  return (
    <Paper sx={{ my: 1, p: 2 }}>
      <Typography mb={2} variant="h6">
        Publicações
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small" sx={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>RPI</StyledTableCell>
              <StyledTableCell align="left">Data de publicação</StyledTableCell>
              <StyledTableCell align="left">Despacho</StyledTableCell>
              <StyledTableCell align="left">Certificado</StyledTableCell>
              <StyledTableCell align="left">Inteiro teor</StyledTableCell>
              <StyledTableCell align="left">Complemento do despacho</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {publicacoes.length > 0 ? (
              publicacoes.map((publicacao, index) => {
                const c = parseComplementosDespacho(publicacao?.complementos_despacho);
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{publicacao?.numero_rpi || "---"}</StyledTableCell>
                    <StyledTableCell>
                      {publicacao?.data_rpi
                        ? moment.utc(publicacao.data_rpi).format("DD/MM/YYYY")
                        : "---"}
                    </StyledTableCell>
                    <StyledTableCell>{publicacao?.despacho || "---"}</StyledTableCell>
                    <StyledTableCell>{publicacao?.certificado || "---"}</StyledTableCell>
                    <StyledTableCell>{publicacao?.inteiro_teor || "---"}</StyledTableCell>
                    <StyledTableCell>
                      {publicacao?.complementos_despacho ? (
                        <Stack direction="column" spacing={0.5} sx={{ fontSize: 14 }}>
                          {c.protocolo && (
                            <Box>
                              <b>Protocolo:</b> {c.protocolo}
                            </Box>
                          )}
                          {c.peticao_tipo && (
                            <Box>
                              <b>Petição (tipo):</b> {c.peticao_tipo}
                            </Box>
                          )}
                          {c.requerente && (
                            <Box>
                              <b>Requerente:</b> {c.requerente}
                            </Box>
                          )}
                          {c.procurador && (
                            <Box>
                              <b>Procurador:</b> {c.procurador}
                            </Box>
                          )}
                        </Stack>
                      ) : (
                        "---"
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box width="100%" p={2} textAlign="center">
                    Nenhuma publicação
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
